import type { AppUser } from '../../../types';

/** "Name (email)" or just the email. */
export function userLabel(user: Pick<AppUser, 'email' | 'displayName'>): string {
  return user.displayName ? `${user.displayName} (${user.email})` : user.email;
}

/** A date in Israel time, e.g. "2 Oct 2026" / "2 באוק׳ 2026". */
export function formatDate(iso: string | undefined, isHebrew: boolean): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(isHebrew ? 'he-IL' : 'en-GB', {
    timeZone: 'Asia/Jerusalem',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** A date and time in Israel time, e.g. "2 Oct 2026, 14:20". */
export function formatDateTime(iso: string | undefined, isHebrew: boolean): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(isHebrew ? 'he-IL' : 'en-GB', {
    timeZone: 'Asia/Jerusalem',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
